import { ConflictGroup } from '../interfaces/ConflictGroup';
import { expand } from './expand';
import { overlap } from './overlap';
import { SurfaceItem } from '../interfaces/SurfaceItem';

/**
 * Groups overlapping surface items into conflict groups
 * Returns a tree of conflict groups with conlficting items
 * Note: if item has no conflicts it is stil returns as a group with a single item
 */
export default function resolveItemsConflicts(input: SurfaceItem[]): ConflictGroup[] {
    let groups: ConflictGroup[] = [];

    // Clone the array, as we'll be mutating it
    // sort by start time as the items may be out of order
    let ungroupedItems = input.slice().sort((a, b) => a.start - b.start);

    while (ungroupedItems.length != 0) {
        let firstItem = ungroupedItems.shift();
        const currentGroup: ConflictGroup = {
            key: firstItem.key,
            start: firstItem.start,
            end: firstItem.end,
            children: [firstItem],
        };

        let i = 0;
        while (i < ungroupedItems.length) {
            let currentItem = ungroupedItems[i];
            if (overlap(currentItem, currentGroup)) {
                currentGroup.children.push(currentItem);
                currentGroup.key += currentItem.key;
                expand(currentGroup, currentItem);
                ungroupedItems.splice(i, 1);
            } else {
                // the item does not overlap with the current group
                i++;
            }
        }

        groups.push(currentGroup);
    }

    return groups;
}

export function isItemConflictingWithOtherEvents(itemId: string, itemList: SurfaceItem[]): boolean {
    let conflictGroups = resolveItemsConflicts(itemList);

    return (
        conflictGroups.filter(
            group => group.children.length > 1 && itemIsPresentInItemList(itemId, group.children)
        ).length > 0
    );
}

function itemIsPresentInItemList(itemId: string, itemList: SurfaceItem[]): boolean {
    return itemId && itemList.filter(curItem => curItem.model.ItemId.Id === itemId).length > 0;
}
